import { lazy } from 'react'
import Menu from '../pages/menu/Menu'
const MenuItems = lazy(() => import('../pages/menu/MenuItems'))
const Reports = lazy(() => import('../pages/reports'))
const Dashboard = lazy(() => import('../pages/dashboard'))

const Offices = lazy(() => import('../pages/offices'))
const OurClients = lazy(() => import('../pages/ourClients'))
const QuestionsAndAnswers = lazy(() => import('../pages/questionsAndAnswers'))
const Rentals = lazy(() => import('../pages/rentals'))
const Users = lazy(() => import('../pages/users'))
const MembershipTab = lazy(() => import('../pages/users/MembershipTab'))
const UserDetails = lazy(() => import('../pages/users/members/UserDetails'))
const officeOptions = lazy(() => import('../pages/office-options'))
const SendEmail = lazy(() => import('../pages/sendEmail'))
const EmailFeedback = lazy(() => import('../pages/feedback'))
const Specifications = lazy(() => import('../pages/settings/specifications'))
const MembershipPlans = lazy(() => import('../pages/settings/membershipPlans'))
const ViewNonMemberDetails = lazy(() => import('../pages/users/nonMembers/ViewNonMemberDetailsPage'))
const Events = lazy(() => import('../pages/events'))
const Payments = lazy(() => import('../pages/payments'))


const routes = [
  { path: '/', element: Dashboard },
  { path: '/dashboard', element: Dashboard },
  { path: '/reports', element: Reports },
  {
    path: '/offices',
    element: Offices
  },
  {
    path: '/our-clients',
    element: OurClients
  },
  {
    path: '/questions-and-answers',
    element: QuestionsAndAnswers
  },
  {
    path: '/rentals',
    element: Rentals
  },
  {
    path: '/users',
    element: Users
  },
  {
    path: '/membership',
    element: MembershipTab
  },
  {
    path: '/users/details/:id',
    element: UserDetails
  },
  {
    path: '/office-options',
    element: officeOptions
  },
  {
    path: '/email',
    element: SendEmail
  },
  {
    path: '/feedback',
    element: EmailFeedback
  },
  {
    path: '/specifications',
    element: Specifications
  },
  {
    path: '/membership-plans',
    element: MembershipPlans
  },
  {
    path: '/users/non-members/details/:id',
    element: ViewNonMemberDetails
  },
  {
    path: '/menu',
    element: Menu
  },
  {
    path: '/menu/items/:id',
    element: MenuItems
  },
  {
    path: '/events',
    element: Events
  },
  {
    path: '/payments',
    element: Payments
  }

]

export default routes
